import { FunctionComponent, memo } from "react";
import { IProps } from "./simple-search-help.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "@edgetier/components";
import "./simple-search-help.scss";

/**
 * Tooltip to explain siple search functionality.
 * @returns Question mark icon that will show a help tooltip on hover.
 */
const SimpleSearchHelp: FunctionComponent<IProps> = () => {
    return (
        <Tooltip
            content={
                <div className="simple-search-help__content">
                    <p>
                        Find interactions with text search. Type any phrase and use the checkboxes to search in agent
                        messages, customer messages, bot messages, system messages, and/or interaction details. Search
                        is not case sensitive.
                    </p>
                    <p>
                        You can combine words and phrases with logic by using inverted commas <code>"</code>. For
                        example:
                    </p>
                    <ul>
                        <li>
                            <code>"wonderful" AND "service"</code> will only return interactions with both terms
                            wonderful and service mentioned.
                        </li>
                        <li>
                            <code>"wonderful" OR "service"</code> will return interactions with either term mentioned.
                        </li>
                    </ul>
                </div>
            }
            placement="bottom-center"
        >
            <div className="simple-search-help">
                <FontAwesomeIcon icon={faQuestionCircle} />
            </div>
        </Tooltip>
    );
};

export default memo(SimpleSearchHelp);
